import React from 'react';
import Title from '../layouts/Title';
import { FaWhatsapp, FaInstagram, FaLinkedinIn, FaEnvelope } from 'react-icons/fa';
import { me } from '../../assets';

const Contact = () => {
  return (
    <section id="contact" className="w-full py-20 border-b-[1px] border-b-black">
      <div className="flex justify-center items-center text-center">
        <Title title="CONTACT" des="Contact With Me" />
      </div>
      <div className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">

          <div className="w-full">
            <div className="w-full h-auto flex flex-col lgl:flex-row justify-between">
              <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#115173] to-[#053F5E] p-8 rounded-lg shadow-shadowOne flex flex-col md:flex-row lgl:flex-col gap-8 justify-center md:justify-start lgl:justify-center">
              <img className="w-full h-full rounded-lg object-cover" src={me} alt="testimonialOne" />
                <div className="w-full flex flex-col justify-end">
                  <p className="text-xs uppercase text-designColor tracking-wide mb-2 font-bold" >Farah Aryaresta</p>
                  <p className="text-base tracking-wide text-gray-300">UIUX Designer | FrontEnd Web Developer</p>
                </div>
              </div>

              <div className="w-full lgl:w-[60%] h-full flex flex-col justify-between">
                <div className="w-full h-[70%] py-10 bg-gradient-to-r from-[#053F5E] to-[#115173] rounded-lg shadow-shadowOne p-4 lgl:p-8 flex flex-col justify-center gap-4 lgl:gap-8">
                  <div className="flex flex-col justify-between lgl:items-center py-6 border-b-2 border-b-gray-900">
                    <h3 className="text-xl lgl:text-2xl font-medium tracking-wide">Tertarik untuk Bekerja Sama? Mari kita bahas proyek Anda dan ciptakan sesuatu yang luar biasa bersama.</h3>
                    <h2 className="text-base text-center font-titleFont mb-4 pt-5">Hubungi saya melalui :</h2>
                    <div className="flex flex-col gap-4">
                      <div className="flex items-center gap-3">
                        <FaWhatsapp className="hover:text-orange-500 text-2xl text-white" />
                        <h2 className="hover:text-orange-500 text-white text-lg font-bold">
                          <a href="https://wa.me/0895363416758" target="_blank" rel="noopener noreferrer">
                            0895363416758
                          </a>
                        </h2>
                      </div>
                      <div className="flex items-center gap-3">
                        <FaEnvelope className="hover:text-orange-500 text-2xl text-white" />
                        <h2 className="hover:text-orange-500 text-white text-lg font-bold">
                          <a href="mailto:faraaryaresta@gmail.com">faraaryaresta@gmail.com</a>
                        </h2>
                      </div>
                      <div className="flex items-center gap-3">
                        <FaInstagram className="hover:text-orange-500 text-2xl text-white" />
                        <h2 className="hover:text-orange-500 text-white text-lg font-bold">
                          <a href="https://instagram.com/faraaryarestaa_" target="_blank" rel="noopener noreferrer">
                            @faraaryarestaa_
                          </a>
                        </h2>
                      </div>
                      
                      <div className="flex items-center gap-3">
                        <FaLinkedinIn className="hover:text-orange-500 text-2xl text-white" />
                        <h2 className="hover:text-orange-500 text-white text-lg font-bold">
                          <a href="https://www.linkedin.com/in/farah-aryaresta-158762244/" target="_blank" rel="noopener noreferrer">
                            Farah Aryaresta
                          </a>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
